'use client';

import { FunctionComponent, ReactNode } from 'react';

export interface PaymentLinkCardProps
{
    title: string;
    children: ReactNode;
    className?: string;
}

/**
 * Component: Common card wrapper for payment link pages.
 */
const PaymentLinkCard: FunctionComponent<PaymentLinkCardProps> = (props) =>
{
    /** Render */
    return (
        <div className={`${props.className ?? 'payment-link-container'} py-5`}>
            <div className="card shadow">
                <div className="card-body p-4 p-md-5">
                    <h1 className="h2 text-center mb-4">
                        {props.title}
                    </h1>
                    
                    {props.children}
                </div>
            </div>
        </div>
    );
}

export default PaymentLinkCard;